import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageService } from '../service/local-storage.service';
import { LocalStorageEnum } from '../../shared/enum.ts/local-storage.enum';

export const superAdminGuard: CanActivateFn = (route, state) => {
  const localStorageService = inject(LocalStorageService);
  const user = localStorageService.getItem(LocalStorageEnum.USER);

  if (user && (user.roleName === 'SUPER_ADMIN' || user.roleName === 'STORE_ADMIN')) {
    return true;
  }

  return false;
};
